<div class="sidenav-content card-items" @routeAnimation>
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<div class="card-title-label" translate>user.card.personalcard</div>
		<div class="card-title-label">{{ firstName }} {{ lastName.toUpperCase() }}</div>
	</div>

	<div class="copo-filter-block">
		<a
				mat-flat-button
				[color]="this.isActivate('/settings/general') ? 'primary' : undefined"
				[class.copo-button-selection-selected]="this.isActivate('/settings/general')"
				class="copo-button-selection copo-button-selection-margin"
				[routerLink]="['/user/card',getRouteParam(),'settings','general']"
				[replaceUrl]="true">
			<span translate>user.card.account-info</span>
		</a>
		<a
				mat-flat-button
				[color]="this.isActivate('/service') || this.isActivate('/manage-service') ? 'primary' : undefined"
				[class.copo-button-selection-selected]="this.isActivate('/service') || this.isActivate('/manage-service')"
				class="copo-button-selection copo-button-selection-margin"
				[routerLink]="['/user/card', getRouteParam(), 'service']"
				[replaceUrl]="true">
			<span translate>user.card.services</span>
		</a>
		<a
				mat-flat-button
				[color]="this.isActivate('/notification') ? 'primary' : undefined"
				[class.copo-button-selection-selected]="this.isActivate('/notification')"
				class="copo-button-selection copo-button-selection-margin"
				[routerLink]="['/user/card', getRouteParam(), 'notification']"
				[replaceUrl]="true">
			<span translate>user.card.notifications</span>
		</a>
		<a *ngIf="isSelfCard()"
				mat-flat-button
				[color]="this.isActivate('/security') ? 'primary' : undefined"
				[class.copo-button-selection-selected]="this.isActivate('/security')"
				class="copo-button-selection copo-button-selection-margin"
				[routerLink]="['/user/card/self/security']"
				[replaceUrl]="true">
			<span translate>user.card.security</span>
		</a>
		<a *ngIf="isSelfCard()"
				mat-flat-button
				[color]="this.isActivate('/privacy-setting') ? 'primary' : undefined"
				[class.copo-button-selection-selected]="this.isActivate('/privacy-setting')"
				class="copo-button-selection copo-button-selection-margin"
				[routerLink]="['/user/card/self/privacy-setting']"
				[replaceUrl]="true">
			<span translate>user.card.privacy-settings</span>
		</a>
	</div>
	<router-outlet></router-outlet>
</div>
